import firebase from 'firebase'
import SystemConstants from '@app/constants/SystemConstants'
import urls from '@app/plugins/urls'
import { accountModule, authModule } from '@app/store'
import { isAuth } from '@app/utils/auth'
export default async function ({
  app: _app,
  store: _store,
  route,
  redirect,
}: {
  app: any
  store: any
  route: { name: string; path: string; fullPath: string }
  redirect: any
}) {
  // Storeが持っている認証状態を確認
  const isAuthenticated = await isAuth()

  if (isAuthenticated) {
    try {
      const user = await accountModule.getUser(true)
    } catch (e) {
      // firebaseで認証は済んでいるがcareproIDに本登録していない状態
      redirect(urls.login)
      return
    }
  }

  const routeName = route.name.split('___')[0]
  if (isAuthenticated && !accountModule.isInitialize) {
    authModule.updateAuthInfo()
    await accountModule.getUser()
  }

  if (isAuthenticated) {
    if (
      !firebase.auth().currentUser?.emailVerified &&
      routeName !== 'carepro-id-auth-mail-verification-send' &&
      routeName.indexOf('mail-reset') == 0 //mail-resetは認証前でも可能にする
    ) {
      redirect(urls.mailverificationResend)
    }
  }

  // 未認証の時、デバイス登録動線ではアカウント作成画面へ遷移させる
  if (!isAuthenticated && routeName === 'id.reg-device-register') {
    redirect(`${urls.accountCreate}/id/?device_register=1`)
    return
  }

  // 未認証かつログインページ以外に飛ぼうとしている場合
  if (!isAuthenticated && routeName !== 'login') {
    localStorage.setItem(SystemConstants.redirectKey, route.fullPath)
    redirect(`${urls.login}?redirect=${route.path}`)
    return
  }

  // 認証済だがログインページに飛ぼうとしている場合は、任意の場所にリダイレクト
  if (isAuthenticated && routeName === 'login') {
    return
  }
}
